import Vue from 'vue';
import VueRouter from 'vue-router';
import { trackPageview } from '@/utils/lpTracker';
import { applyRouteMeta } from '@/utils/pageMeta';

Vue.use(VueRouter);

let router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // Sem isto, ir da home rolada para /revenda ou /tablet abria a página nova no meio.
  // Mesma rota com query diferente não mexe no scroll.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.path !== from.path) return { x: 0, y: 0 };
    return false;
  },
  routes: [
    {
      path: '/',
      component: () => import('../pages/home/Home'),
    },
    {
      path: '/tablet',
      component: () => import('../pages/tablet/Tablet'),
    },
    {
      path: '/revenda',
      component: () => import('../pages/revenda/Revenda'),
    },
    {
      path: '/revenda/whatsapp',
      component: () => import('../pages/revenda/RevendaWhatsapp'),
    },
    {
      path: '/whatsapp',
      component: () => import('../pages/whatsapp/Whatsapp'),
    },
    {
      path: '/obrigado',
      component: () => import('../pages/thanks/Thanks'),
    },
    {
      path: '/planos',
      component: () => import('../pages/planos/Planos'),
    },
    {
      path: '/checkout',
      component: () => import('../pages/checkout/Checkout'),
    },
    {
      path: '/preview',
      component: () => import('../pages/preview/Preview'),
    },
    {
      path: '/pagamento',
      component: () => import('../pages/pagamento/Pagamento'),
    },
    {
      path: '/confirmacao',
      component: () => import('../pages/confirmacao/Confirmacao'),
    },
    {
      path: '*',
      component: () => import('../pages/notfound/NotFound'),
    },
  ],
});

router.afterEach((to) => {
  // Título/description/robots/canonical/OG/JSON-LD da rota — ver [src/seo/site.js].
  // Rota desconhecida cai no meta de 404 (noindex).
  applyRouteMeta(to.path);

  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path:  to.fullPath,
      page_title: document.title,
    });
  }
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }

  // Tracking interno — ignora a primeira navegação (o App.vue inicializa o tracker
  // com o primeiro path, então o primeiro pageview é registrado lá)
  trackPageview(to.path);
});

export default router;
